import {FIRM_URL} from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";

export const AdminGreenPagesService = {
  getAll: (params: any) => requests.get(`${FIRM_URL}`, params),
  create: (params: any) => requests.post(`${FIRM_URL}`, params, true),
  getSingle: (id: number) => requests.get(`${FIRM_URL}/${id}`),
  update: (params: any, id: number) =>
    requests.post(`${FIRM_URL}/${id}`, params, true),
  updatePosition: (params: any) => requests.patch(`${FIRM_URL}`, params),
  delete: (id: number) => requests.delete(`${FIRM_URL}/${id}`),
};
